import axios from 'axios';
import { cookieUtils } from 'helpers/cookiesUtils';
import logoutHandler from 'helpers/logoutHandler';

const { createCookies } = cookieUtils;

const cookieOptions = {
    sameSite: 'none',
    secure: true,
    path: '/',
};

let isRefreshing = false;
let refreshSubscribers = [];

function subscribeTokenRefresh(callback) {
    refreshSubscribers.push(callback);
}

function onRefreshTokenSuccess(newAccessToken) {
    refreshSubscribers.forEach((callback) => callback(newAccessToken));
    refreshSubscribers = [];
}

function onRefreshTokenFailure() {
    refreshSubscribers.forEach((callback) => callback(null));
    refreshSubscribers = [];
}

export function execWithCheckingNewToken(callback, timeoutMs, accessToken) {
    const { getCookies } = cookieUtils;
    if (typeof callback !== 'function') return;

    setTimeout(() => {
        const { tokens } = getCookies();
        const finalToken = accessToken || tokens?.accessToken;

        if (finalToken) {
            callback(finalToken);
            return;
        }

        // retry loop
        execWithCheckingNewToken(callback, timeoutMs, accessToken);
    }, timeoutMs);
}

function refreshToken(callback) {
    // If already refreshing, add callback to queue and return
    if (isRefreshing) {
        subscribeTokenRefresh((newToken) => {
            if (newToken && typeof callback === 'function') {
                callback(newToken);
            }
        });
        return;
    }

    isRefreshing = true;

    const { getCookies } = cookieUtils;
    const { tokens } = getCookies();

    axios
        .post(`${process.env.REACT_APP_API_BASE_URL}/api/v1/refresh-token`, { refresh_token: tokens?.refreshToken || '' }, { withCredentials: true })
        .then((response) => {
            if (response?.data?.code === 0) {
                const newAccess = response?.data?.data?.access_token;
                const newRefresh = response?.data?.data?.refresh_token;

                createCookies(
                    'tokens',
                    {
                        refreshToken: newRefresh,
                        accessToken: newAccess,
                    },
                    { ...cookieOptions, expires: 7 },
                    false
                );

                onRefreshTokenSuccess(newAccess);

                if (typeof callback === 'function') {
                    execWithCheckingNewToken(callback, 500, newAccess);
                }
            } else {
                onRefreshTokenFailure();
                logoutHandler();
            }
        })
        .catch(() => {
            onRefreshTokenFailure();
            logoutHandler();
        })
        .finally(() => {
            isRefreshing = false;
        });
}

export default refreshToken;
